"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT_FETCH_ALL_LIMIT = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _clientLibrary = require("@seneca/client-library");
var _UserStatsNotFoundError = _interopRequireDefault(require("./errors/UserStatsNotFoundError"));
var _InvalidArgumentError = _interopRequireDefault(require("./errors/InvalidArgumentError"));
var _UnauthorisedStatsAccessError = _interopRequireDefault(require("./errors/UnauthorisedStatsAccessError"));
var _ForbiddenStatsAccessError = _interopRequireDefault(require("./errors/ForbiddenStatsAccessError"));
var _dateToEpochSeconds = _interopRequireDefault(require("./utils/dateToEpochSeconds"));
var _removeDuplicatePrimitives = _interopRequireDefault(require("./utils/removeDuplicatePrimitives"));
var _buildUrlFromIds = _interopRequireDefault(require("./utils/buildUrlFromIds"));
var _parseUserStats = _interopRequireDefault(require("./utils/parseUserStats"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DEFAULT_FETCH_ALL_LIMIT = 100;

/**
 * StatsServiceClient
 * @param {Object} options options object input data and dependency injection
 * @param {Object} options.fetch change fetch method from whatwg-fetch (optional, default: whatwg-fetch)
 * @param {string} options.protocol the http protocol of the service endpoint
 * @param {string} options.host the host of the service endpoint
 * @param {string} options.path the path of the service endpoint (optional)
 * @param {number} options.retries the number of times the client should retry on network error / service error (optional, default: 3)
 * @param {number} options.delayInSecs the delay between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional)
 * @param {string} options.region states the region of the service for signing (optional, default: eu-west-1)
 * @param {RequestMaker} options.requestMaker for overriding request making logic (optional, default: RequestMaker)
 * @throws {UrlConstructionError} when either options.protocol or options.host is missing
 */
exports.DEFAULT_FETCH_ALL_LIMIT = DEFAULT_FETCH_ALL_LIMIT;
var StatsServiceClient = /*#__PURE__*/function (_Client) {
  (0, _inherits2.default)(StatsServiceClient, _Client);
  var _super = _createSuper(StatsServiceClient);
  function StatsServiceClient(fetch, options) {
    (0, _classCallCheck2.default)(this, StatsServiceClient);
    return _super.call(this, fetch, options);
  }
  (0, _createClass2.default)(StatsServiceClient, [{
    key: "emitSession",
    value: function () {
      var _emitSession = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(session) {
        var stringifiedBody, unicodeNormalisedBody;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              stringifiedBody = JSON.stringify(session);
              unicodeNormalisedBody = String.prototype.normalize ? stringifiedBody.normalize('NFC') : stringifiedBody;
              _context.next = 4;
              return this.requestMaker.makeRequest("".concat(this.url, "/api/stats/sessions"), {
                method: 'POST',
                body: unicodeNormalisedBody
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function emitSession(_x) {
        return _emitSession.apply(this, arguments);
      }
      return emitSession;
    }()
  }, {
    key: "fetchUserStats",
    value: function () {
      var _fetchUserStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this._fetchStatForUser("".concat(this.url, "/api/stats/users")));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchUserStats() {
        return _fetchUserStats.apply(this, arguments);
      }
      return fetchUserStats;
    }()
    /**
     * Fetches all course stats
     * @param {number} options.limit - the limit returned in each pagination response (optional)
     * @param {string} options.lastKey - the key of the last item returned to fetch from (optional)
     */
  }, {
    key: "fetchAllCourseStatsForUser",
    value: function () {
      var _fetchAllCourseStatsForUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var options,
          _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              return _context3.abrupt("return", this._pageMethod({
                method: this.fetchPageOfAllStatsForUser.bind(this),
                pageToItems: function pageToItems(page) {
                  return page.stats;
                },
                options: _objectSpread(_objectSpread({}, options), {}, {
                  url: "".concat(this.url, "/api/stats/courses/user")
                })
              }));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchAllCourseStatsForUser() {
        return _fetchAllCourseStatsForUser.apply(this, arguments);
      }
      return fetchAllCourseStatsForUser;
    }()
    /**
     * Fetches all section stats for a specific course
     * @param {string} courseId - the id of the course to fetch section stats for
     * @param {number} options.limit - the limit returned in each pagination response (optional)
     * @param {string} options.lastKey - the key of the last item returned to fetch from (optional)
     */
  }, {
    key: "fetchCourseSectionStatsForUser",
    value: function () {
      var _fetchCourseSectionStatsForUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(courseId) {
        var options,
          _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
              if (courseId) {
                _context4.next = 3;
                break;
              }
              throw new _clientLibrary.MissingParamError('courseId');
            case 3:
              return _context4.abrupt("return", this._pageMethod({
                method: this.fetchPageOfAllStatsForUser.bind(this),
                pageToItems: function pageToItems(page) {
                  return page.stats;
                },
                options: _objectSpread(_objectSpread({}, options), {}, {
                  courseId: courseId,
                  url: "".concat(this.url, "/api/stats/sections")
                })
              }));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchCourseSectionStatsForUser(_x2) {
        return _fetchCourseSectionStatsForUser.apply(this, arguments);
      }
      return fetchCourseSectionStatsForUser;
    }()
    /**
     * Fetches all content stats for a specific course
     * @param {string} courseId - the id of the course to fetch content stats for
     * @param {number} options.limit - the limit returned in each pagination response (optional)
     * @param {string} options.lastKey - the key of the last item returned to fetch from (optional)
     */
  }, {
    key: "fetchCourseContentStatsForUser",
    value: function () {
      var _fetchCourseContentStatsForUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(courseId) {
        var options,
          _args5 = arguments;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              if (courseId) {
                _context5.next = 3;
                break;
              }
              throw new _clientLibrary.MissingParamError('courseId');
            case 3:
              return _context5.abrupt("return", this._pageMethod({
                method: this.fetchPageOfAllStatsForUser.bind(this),
                pageToItems: function pageToItems(page) {
                  return page.stats;
                },
                options: _objectSpread(_objectSpread({}, options), {}, {
                  courseId: courseId,
                  url: "".concat(this.url, "/api/stats/contents")
                })
              }));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchCourseContentStatsForUser(_x3) {
        return _fetchCourseContentStatsForUser.apply(this, arguments);
      }
      return fetchCourseContentStatsForUser;
    }()
  }, {
    key: "fetchPageOfAllStatsForUser",
    value: function () {
      var _fetchPageOfAllStatsForUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(options) {
        var url, params;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = options.url;
              params = this._generatePagingQueryParams(options);
              if (options.courseId) {
                params.unshift("courseId=".concat(options.courseId));
              }
              if (params.length !== 0) {
                url += "?".concat(params.join('&'));
              }
              return _context6.abrupt("return", this._fetchStatForUser(url));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fetchPageOfAllStatsForUser(_x4) {
        return _fetchPageOfAllStatsForUser.apply(this, arguments);
      }
      return fetchPageOfAllStatsForUser;
    }()
  }, {
    key: "adminFetchAllCourseStatsForUser",
    value: function () {
      var _adminFetchAllCourseStatsForUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(userId, options) {
        var _this = this;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this._pageMethod({
                method: function method(options) {
                  return _this.adminFetchPageOfAllCourseStatsForUser(userId, options);
                },
                pageToItems: function pageToItems(page) {
                  return page.stats;
                },
                options: options
              }));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function adminFetchAllCourseStatsForUser(_x5, _x6) {
        return _adminFetchAllCourseStatsForUser.apply(this, arguments);
      }
      return adminFetchAllCourseStatsForUser;
    }()
  }, {
    key: "adminFetchPageOfAllCourseStatsForUser",
    value: function () {
      var _adminFetchPageOfAllCourseStatsForUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(userId, options) {
        var url, params;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (userId) {
                _context8.next = 2;
                break;
              }
              throw new _InvalidArgumentError.default('userId');
            case 2:
              url = "".concat(this.url, "/api/admin/stats/user/").concat(userId, "/courses");
              params = this._generatePagingQueryParams(options);
              if (params.length !== 0) {
                url += "?".concat(params.join('&'));
              }
              return _context8.abrupt("return", this._fetchStatForUser(url));
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function adminFetchPageOfAllCourseStatsForUser(_x7, _x8) {
        return _adminFetchPageOfAllCourseStatsForUser.apply(this, arguments);
      }
      return adminFetchPageOfAllCourseStatsForUser;
    }()
  }, {
    key: "adminFetchWindowedCourseStatForUser",
    value: function () {
      var _adminFetchWindowedCourseStatForUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(_ref) {
        var courseId, userId, startEpochSeconds, endEpochSeconds, url, params;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              courseId = _ref.courseId, userId = _ref.userId, startEpochSeconds = _ref.startEpochSeconds, endEpochSeconds = _ref.endEpochSeconds;
              if (userId) {
                _context9.next = 3;
                break;
              }
              throw new _InvalidArgumentError.default('userId');
            case 3:
              if (courseId) {
                _context9.next = 5;
                break;
              }
              throw new _InvalidArgumentError.default('courseId');
            case 5:
              url = "".concat(this.url, "/api/admin/stats/user/").concat(userId, "/windowed/course/").concat(courseId);
              params = this._generateWindowQueryParams({
                startTime: startEpochSeconds,
                endTime: endEpochSeconds
              });
              if (params.length !== 0) {
                url += "?".concat(params.join('&'));
              }
              return _context9.abrupt("return", this._fetchStatForUser(url));
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function adminFetchWindowedCourseStatForUser(_x9) {
        return _adminFetchWindowedCourseStatForUser.apply(this, arguments);
      }
      return adminFetchWindowedCourseStatForUser;
    }()
  }, {
    key: "_fetchStatForUser",
    value: function () {
      var _fetchStatForUser2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(url) {
        var expectedResponses, response;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              expectedResponses = [200, 404];
              _context10.next = 3;
              return this.requestMaker.makeRequest(url, {
                method: 'GET'
              }, expectedResponses);
            case 3:
              response = _context10.sent;
              if (!(response.status === 404)) {
                _context10.next = 6;
                break;
              }
              throw new _UserStatsNotFoundError.default();
            case 6:
              if (!(response.status === 200)) {
                _context10.next = 8;
                break;
              }
              return _context10.abrupt("return", response.json);
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function _fetchStatForUser(_x10) {
        return _fetchStatForUser2.apply(this, arguments);
      }
      return _fetchStatForUser;
    }() /*  Fetch Collection  */
  }, {
    key: "fetchUserContentModulesStats",
    value: function () {
      var _fetchUserContentModulesStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(ids) {
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.fetchStatCollection('/api/stats/modules', ids));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function fetchUserContentModulesStats(_x11) {
        return _fetchUserContentModulesStats.apply(this, arguments);
      }
      return fetchUserContentModulesStats;
    }()
  }, {
    key: "fetchUserContentsStats",
    value: function () {
      var _fetchUserContentsStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(ids) {
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.fetchStatCollection('/api/stats/contents', ids));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function fetchUserContentsStats(_x12) {
        return _fetchUserContentsStats.apply(this, arguments);
      }
      return fetchUserContentsStats;
    }()
  }, {
    key: "fetchUserSectionsStats",
    value: function () {
      var _fetchUserSectionsStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(ids) {
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this.fetchStatCollection('/api/stats/sections', ids));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function fetchUserSectionsStats(_x13) {
        return _fetchUserSectionsStats.apply(this, arguments);
      }
      return fetchUserSectionsStats;
    }()
  }, {
    key: "fetchUserCoursesStats",
    value: function () {
      var _fetchUserCoursesStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(ids) {
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this.fetchStatCollection('/api/stats/courses', ids));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function fetchUserCoursesStats(_x14) {
        return _fetchUserCoursesStats.apply(this, arguments);
      }
      return fetchUserCoursesStats;
    }()
  }, {
    key: "fetchStatCollection",
    value: function () {
      var _fetchStatCollection = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(path, ids) {
        var saneIds, requests, fullPath, request, responses;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              saneIds = (0, _removeDuplicatePrimitives.default)(ids);
              requests = [];
              while (saneIds.length > 0) {
                fullPath = (0, _buildUrlFromIds.default)(path, saneIds);
                request = this.requestMaker.makeRequest("".concat(this.url).concat(fullPath), {
                  method: 'GET'
                });
                requests.push(request.then(function (res) {
                  return res.json;
                }));
              }
              _context15.next = 5;
              return Promise.all(requests);
            case 5:
              responses = _context15.sent;
              return _context15.abrupt("return", responses.reduce(function (reducedRes, currentRes) {
                var _reducedRes$stats;
                reducedRes.count += currentRes.count;
                (_reducedRes$stats = reducedRes.stats).push.apply(_reducedRes$stats, (0, _toConsumableArray2.default)(currentRes.stats));
                return reducedRes;
              }, {
                count: 0,
                stats: []
              }));
            case 7:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function fetchStatCollection(_x15, _x16) {
        return _fetchStatCollection.apply(this, arguments);
      }
      return fetchStatCollection;
    }()
  }, {
    key: "fetchWindowedUserCourseStats",
    value: function () {
      var _fetchWindowedUserCourseStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(userId, startTime, endTime, withStatsGroupedByDateRanges) {
        var expectedResponses, lastKey, responses, url, queryParams, params, response, responseStartTime, responseEndTime, groupedStatsByDateRanges, stats;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              expectedResponses = [200, 401, 403];
              responses = [];
            case 2:
              url = "".concat(this.url, "/api/stats/users/").concat(userId, "/windowed/courses");
              queryParams = {
                startTime: startTime,
                endTime: endTime
              };
              if (withStatsGroupedByDateRanges) {
                Object.assign(queryParams, {
                  withStatsGroupedByDateRanges: true
                });
              }
              params = this._generateWindowQueryParams(queryParams);
              if (lastKey) {
                params.push("lastKey=".concat(encodeURIComponent(lastKey)));
              }
              if (params.length !== 0) {
                url += "?".concat(params.join('&'));
              }
              _context16.next = 10;
              return this.requestMaker.makeRequest(url, {
                method: 'GET'
              }, expectedResponses);
            case 10:
              response = _context16.sent;
              if (!(response.status === 403)) {
                _context16.next = 13;
                break;
              }
              throw new _ForbiddenStatsAccessError.default();
            case 13:
              if (!(response.status === 401)) {
                _context16.next = 15;
                break;
              }
              throw new _UnauthorisedStatsAccessError.default();
            case 15:
              if (response.status === 200) {
                lastKey = response.json.lastKey;
                responses.push(response.json);
              }
            case 16:
              if (lastKey) {
                _context16.next = 2;
                break;
              }
            case 17:
              responseStartTime = responses.length ? responses[0].startTime : null;
              responseEndTime = responses.length ? responses[0].endTime : null;
              groupedStatsByDateRanges = responses.length ? responses[0].groupedStatsByDateRanges : null;
              stats = responses.reduce(function (acc, response) {
                return _objectSpread(_objectSpread({}, acc), response.stats);
              }, {});
              return _context16.abrupt("return", StatsServiceClient._parseWindowedMultiCourseStats({
                userId: userId,
                startTime: responseStartTime,
                endTime: responseEndTime,
                stats: stats,
                groupedStatsByDateRanges: groupedStatsByDateRanges
              }));
            case 22:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function fetchWindowedUserCourseStats(_x17, _x18, _x19, _x20) {
        return _fetchWindowedUserCourseStats.apply(this, arguments);
      }
      return fetchWindowedUserCourseStats;
    }()
  }, {
    key: "fetchWindowedMultiUserCourseStats",
    value: function () {
      var _fetchWindowedMultiUserCourseStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(_ref2) {
        var contextId, userIds, courseId, startTime, endTime, expectedResponses, url, params, response;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              contextId = _ref2.contextId, userIds = _ref2.userIds, courseId = _ref2.courseId, startTime = _ref2.startTime, endTime = _ref2.endTime;
              expectedResponses = [200, 401];
              url = "".concat(this.url, "/api/stats/users/windowed/courses/").concat(courseId);
              params = this._generateWindowQueryParams({
                startTime: startTime,
                endTime: endTime
              });
              if (params.length !== 0) {
                url += "?".concat(params.join('&'));
              }
              _context17.next = 7;
              return this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({
                  userIds: userIds,
                  contextId: contextId
                })
              }, expectedResponses);
            case 7:
              response = _context17.sent;
              if (!(response.status === 401)) {
                _context17.next = 10;
                break;
              }
              throw new _UnauthorisedStatsAccessError.default();
            case 10:
              if (!(response.status === 200)) {
                _context17.next = 12;
                break;
              }
              return _context17.abrupt("return", StatsServiceClient._parseWindowedMultiUserCourseStats(response.json));
            case 12:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function fetchWindowedMultiUserCourseStats(_x21) {
        return _fetchWindowedMultiUserCourseStats.apply(this, arguments);
      }
      return fetchWindowedMultiUserCourseStats;
    }()
  }, {
    key: "adminFetchAggregatedUserSectionStats",
    value: function () {
      var _adminFetchAggregatedUserSectionStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(_ref3) {
        var courseId, sectionIds, userIds, bestScoreThreshold, expectedResponses, url, response;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              courseId = _ref3.courseId, sectionIds = _ref3.sectionIds, userIds = _ref3.userIds, bestScoreThreshold = _ref3.bestScoreThreshold;
              expectedResponses = [200, 400];
              url = "".concat(this.url, "/api/admin/stats/sections/aggregated");
              _context18.next = 5;
              return this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({
                  courseId: courseId,
                  sectionIds: sectionIds,
                  userIds: userIds,
                  bestScoreThreshold: bestScoreThreshold
                })
              }, expectedResponses);
            case 5:
              response = _context18.sent;
              if (!(response.status === 400)) {
                _context18.next = 8;
                break;
              }
              throw new _InvalidArgumentError.default(response.json.pointer, response.json.reason);
            case 8:
              return _context18.abrupt("return", response.json);
            case 9:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function adminFetchAggregatedUserSectionStats(_x22) {
        return _adminFetchAggregatedUserSectionStats.apply(this, arguments);
      }
      return adminFetchAggregatedUserSectionStats;
    }()
  }, {
    key: "fetchAggregatedEnrichedUserSectionStats",
    value: function () {
      var _fetchAggregatedEnrichedUserSectionStats = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(_ref4) {
        var userIds, sectionId, courseId, schoolId, expectedResponses, url, response;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              userIds = _ref4.userIds, sectionId = _ref4.sectionId, courseId = _ref4.courseId, schoolId = _ref4.schoolId;
              expectedResponses = [200, 400, 403];
              url = "".concat(this.url, "/api/stats/sections/").concat(sectionId, "/enriched");
              _context19.next = 5;
              return this.requestMaker.makeRequest(url, {
                method: 'POST',
                body: JSON.stringify({
                  userIds: userIds,
                  courseId: courseId,
                  schoolId: schoolId
                })
              }, expectedResponses);
            case 5:
              response = _context19.sent;
              if (!(response.status === 400)) {
                _context19.next = 8;
                break;
              }
              throw new _InvalidArgumentError.default(response.json.pointer, response.json.reason);
            case 8:
              if (!(response.status === 403)) {
                _context19.next = 10;
                break;
              }
              throw new _ForbiddenStatsAccessError.default();
            case 10:
              return _context19.abrupt("return", response.json);
            case 11:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function fetchAggregatedEnrichedUserSectionStats(_x23) {
        return _fetchAggregatedEnrichedUserSectionStats.apply(this, arguments);
      }
      return fetchAggregatedEnrichedUserSectionStats;
    }()
  }, {
    key: "_generateWindowQueryParams",
    value: function _generateWindowQueryParams() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        startTime = _ref5.startTime,
        endTime = _ref5.endTime,
        withStatsGroupedByDateRanges = _ref5.withStatsGroupedByDateRanges;
      var params = [];
      typeof startTime === 'number' && params.push("startTime=".concat(startTime));
      typeof endTime === 'number' && params.push("endTime=".concat(endTime));
      typeof withStatsGroupedByDateRanges === 'boolean' && params.push("withStatsGroupedByDateRanges=true");
      return params;
    }
  }], [{
    key: "_parseWindowedMultiCourseStats",
    value: function _parseWindowedMultiCourseStats(_ref6) {
      var stats = _ref6.stats,
        userId = _ref6.userId,
        startTime = _ref6.startTime,
        endTime = _ref6.endTime,
        groupedStatsByDateRanges = _ref6.groupedStatsByDateRanges;
      var parsedResponse = {
        userId: userId
      };
      if (startTime) {
        parsedResponse.startTime = (0, _dateToEpochSeconds.default)(new Date(startTime));
      }
      if (endTime) {
        parsedResponse.endTime = (0, _dateToEpochSeconds.default)(new Date(endTime));
      }
      if (stats) {
        parsedResponse.stats = {};
        Object.keys(stats).forEach(function (courseId) {
          var courseStats = stats[courseId];
          parsedResponse.stats[courseId] = (0, _parseUserStats.default)(courseStats);
        });
      }
      if (groupedStatsByDateRanges) {
        parsedResponse.groupedStatsByDateRanges = groupedStatsByDateRanges;
      }
      return parsedResponse;
    }
  }, {
    key: "_parseWindowedMultiUserCourseStats",
    value: function _parseWindowedMultiUserCourseStats(response) {
      var parsedResponse = {
        courseId: response.courseId,
        userIds: response.userIds
      };
      if (response.startTime) {
        parsedResponse.startTime = (0, _dateToEpochSeconds.default)(new Date(response.startTime));
      }
      if (response.endTime) {
        parsedResponse.endTime = (0, _dateToEpochSeconds.default)(new Date(response.endTime));
      }
      if (response.stats) {
        parsedResponse.stats = {};
        Object.keys(response.stats).forEach(function (userId) {
          var userStats = response.stats[userId];
          var parsedUserStats = _objectSpread({
            userId: userId
          }, (0, _parseUserStats.default)(userStats));
          if (userStats.earliestStudySession) {
            parsedUserStats.earliestStudySession = (0, _dateToEpochSeconds.default)(new Date(userStats.earliestStudySession));
          }
          if (userStats.latestStudySession) {
            parsedUserStats.latestStudySession = (0, _dateToEpochSeconds.default)(new Date(userStats.latestStudySession));
          }
          parsedResponse.stats[userId] = parsedUserStats;
        });
      }
      return parsedResponse;
    }
  }]);
  return StatsServiceClient;
}(_clientLibrary.Client);
exports.default = StatsServiceClient;